var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 17.4999C3.58424 17.4999 3.42527 17.4341 3.30806 17.3169C3.19085 17.1997 3.125 17.0407 3.125 16.8749V3.12494C3.12499 3.01633 3.15329 2.90959 3.2071 2.81524C3.26091 2.7209 3.33838 2.6422 3.43187 2.58692C3.52537 2.53164 3.63165 2.50167 3.74025 2.49997C3.84885 2.49828 3.95602 2.52492 4.05119 2.57726L16.5512 9.45226C16.6493 9.50619 16.731 9.58546 16.788 9.68179C16.845 9.77813 16.875 9.888 16.875 9.99991C16.875 10.1118 16.845 10.2217 16.788 10.318C16.731 10.4144 16.6493 10.4936 16.5512 10.5476L4.05119 17.4226C3.95891 17.4733 3.85531 17.4999 3.75 17.4999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlay);
export default __webpack_public_path__ + "static/media/ic-play.52a39b8966d601f72f4f767e869ec1f7.svg";
export { ForwardRef as ReactComponent };